
import React from "react";
import { Linkedin, Instagram, Youtube } from "lucide-react";

export interface SocialLink {
  name: string;
  url: string;
  icon: React.FC<{ className?: string }> | (() => JSX.Element);
  color: string;
}

interface SocialLinksProps {
  links: SocialLink[];
}

const SocialLinks: React.FC<SocialLinksProps> = ({ links }) => {
  return (
    <div className="flex gap-2 sm:gap-3 mt-2 sm:mt-3 mb-4 sm:mb-6 justify-center lg:justify-start w-full">
      {links.map((social) => (
        <a 
          key={social.name}
          href={social.url}
          target="_blank" 
          rel="noopener noreferrer"
          className="flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-sage-800 hover:bg-sage-700 transition-colors duration-300"
          style={{ color: social.color }}
          aria-label={social.name}
          title={social.name}
        >
          {typeof social.icon === 'function' ? 
            <social.icon className="h-4 w-4 sm:h-5 sm:w-5" /> : 
            React.createElement(social.icon, { className: "h-4 w-4 sm:h-5 sm:w-5" })}
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;
